/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_ReviewsInputs */

const en_directory_detail_section_reviews = /** @type {(inputs: Directory_Detail_Section_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviews`)
};

const zh_directory_detail_section_reviews = /** @type {(inputs: Directory_Detail_Section_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评价`)
};

/**
* | output |
* | --- |
* | "Reviews" |
*
* @param {Directory_Detail_Section_ReviewsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_reviews = /** @type {((inputs?: Directory_Detail_Section_ReviewsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_ReviewsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_reviews(inputs)
	return zh_directory_detail_section_reviews(inputs)
});
export { directory_detail_section_reviews as "directory.detail.section.reviews" }